import { render, staticRenderFns } from "./RecordCostUnitAmountTable.vue?vue&type=template&id=27c99b81"
import script from "./RecordCostUnitAmountTable.vue?vue&type=script&lang=js"
export * from "./RecordCostUnitAmountTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports